import { createContext } from "react";

import { ResolutionsListingFilters } from "../listing/useResolutionsListingFilters";
import { ResolutionListingItem } from "./ResolutionListingItem";

interface IResolutionsListingContext {
    allItems: ResolutionListingItem[];
    items: ResolutionListingItem[];
    isLoading: boolean;
    totalItems: number;
    add(item: ResolutionListingItem): void;
    load(filters: ResolutionsListingFilters): void;
}

export const ResolutionsListingContext = createContext<IResolutionsListingContext>({} as IResolutionsListingContext);
